import { PencilSimpleIcon } from '@c/icons';
import Banner from '@ui/Banner';
import Button from '@ui/Button';
import { ProductDocument } from 'models/product';
import { useAuth } from 'context/AuthContext';
import React from 'react';

const DraftBanner = ({ product }: { product: ProductDocument }) => {
  const { userDoc } = useAuth();
  return (
    <Banner color="brand" rounded>
      <div className="flex items-center justify-center gap-[0.8rem] rounded-[2rem]">
        <PencilSimpleIcon />
        This is a draft listing.
        {userDoc &&
          (userDoc.uid === product.seller_id || userDoc.roles?.admin) && (
            <Button
              height="extraSmall"
              text="( Edit Listing )"
              type="text"
              width="extraSmall"
              href={`/edit-listing/${product.id}`}
            />
          )}
      </div>
    </Banner>
  );
};

export default DraftBanner;
